import { render, staticRenderFns } from "./right-arrow-icon.vue?vue&type=template&id=1091baa5&scoped=true&lang=pug&"
import script from "./right-arrow-icon.vue?vue&type=script&lang=js&"
export * from "./right-arrow-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091baa5",
  null
  
)

export default component.exports